<template>
    <router-view/>
</template>

<script>

export default {
  name: 'App',

  mounted() {
    
  },
}

</script>



// WEBPACK FOOTER //
// src/App.vue